export default "__VITE_ASSET__vZp_bB8r__"